import cart, { CartState } from '../cart/reducer';
import dashboard, { State as DashboardState } from '../dashboard/reducer';
import device, { State as DeviceState } from '../device/reducer';
import diagnosticMessages, { State as DiagnosticMessagesState } from '../diagnosticMessages/reducer';
import eventDetails, { State as EventDetailsState } from '../eventDetails/reducer';
import guest, { State as GuestState } from '../guest/reducer';
import menu, { State as MenuState } from '../menu/reducer';
import order, { type State as OrderState } from '../order/reducers';
import user, { State as UserState } from '../user/reducer';

export type State = {
  cart: CartState;
  dashboard: DashboardState;
  device: DeviceState;
  eventDetails: EventDetailsState;
  guest: GuestState;
  menu: MenuState;
  order: OrderState;
  user: UserState;
  diagnosticMessages: DiagnosticMessagesState;
};

export default {
  cart,
  menu,
  user,
  order,
  guest,
  device,
  dashboard,
  diagnosticMessages,
  eventDetails,
};
